import { Component, EventEmitter, input, Output, ViewEncapsulation } from '@angular/core';

import { IThread } from '@lb/api/mylb/interfaces';
import { MDIconComponent, MDHeaderComponent, MDTagComponent } from '@melodic-ui/components';

@Component({
	selector: 'lrnr-conversation-list',
	standalone: true,
	imports: [MDIconComponent, MDHeaderComponent, MDTagComponent],
	templateUrl: './conversation-list.component.html',
	styleUrl: './conversation-list.component.scss',
	encapsulation: ViewEncapsulation.None
})
export class ConversationListComponent {
	conversations = input.required<IThread[]>();
	activeConversationId = input<string | null>(null);

	@Output() conversationSelected = new EventEmitter<string>();
	@Output() newConversationRequested = new EventEmitter<void>();

	selectConversation(id: string): void {
		this.conversationSelected.emit(id);
	}

	createNewConversation(): void {
		this.newConversationRequested.emit();
	}

	getFormattedDate(date: Date): string {
		const now = new Date();
		const messageDate = new Date(date);
		const diffMs = now.getTime() - messageDate.getTime();
		const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

		if (diffDays === 0) return 'Today';
		if (diffDays === 1) return 'Yesterday';
		if (diffDays < 7) return `${diffDays}d ago`;

		return messageDate.toLocaleDateString('en-US', {
			month: 'short',
			day: 'numeric'
		});
	}
}
